var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calendar-picker-reservation" },
    [
      _c("div", { staticClass: "header" }, [
        _vm._v(_vm._s(_vm.$t("calendar.reservationSidebarFilter"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-wrapper" },
        [
          _c("a-input-search", {
            attrs: { placeholder: _vm.$t("message.inputSearchText") },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.myReservations, function (myReservation) {
        return _c(
          "div",
          {
            staticClass: "list-item",
            on: {
              click: function ($event) {
                return _vm.changeCalendar(myReservation._id)
              },
            },
          },
          [_vm._v("\n        " + _vm._s(myReservation.title) + "\n    ")]
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "group-title" }, [
        _vm._v(_vm._s(_vm.$t("calendar.agents"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list-items" },
        _vm._l(_vm.getFilteredOtherReservations(), function (reservation) {
          return _c(
            "div",
            {
              staticClass: "list-item",
              on: {
                click: function ($event) {
                  return _vm.changeCalendar(reservation._id)
                },
              },
            },
            [
              _c("AgentAvatar", {
                attrs: {
                  size: 25,
                  userID: reservation.userId._id,
                  "font-size": 15,
                },
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(reservation.userId.name + " / " + reservation.title)
                ),
              ]),
            ],
            1
          )
        }),
        0
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }